import styled from "styled-components";

export const SalesModeLayoutWrapper = styled.main`
    width: 100%;
    height: 100dvh;
    background: #f9f9f9;
    .sales-layout__main-content {
        margin-top: 150px;
        z-index: 0;
        width: 100%;
        margin: 0 auto;
        height: calc(100dvh - 80px);
    }
`;

export const NavigationBarContainer = styled.header`
    position: sticky;
    top: 0;
    width: 100%;
    background: #000;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 80px;
    height: 80px;
    z-index: 10000;

    .sales__nav-right-wrap {
        display: flex;
        align-items: center;
        gap: 20px;
        .sales_nav-logout-wrap {
            display: flex;
            cursor: pointer;
            gap: 4px;
            align-items: center;
            p {
                color: #fff;
                font-size: 0.813rem;
                font-weight: 800;
                line-height: normal;
            }
        }
    }
    @media (max-width: 767px) {
        height: 70px;
        padding: 0px 26px 0px 23px;
        .sales__nav-right-wrap {
            display: none;
        }
    }
`;

export const NavigationItemsWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    .sales__nav-item {
        padding: 12px 16px;

        p {
            color: #cacaca;
            font-size: 0.938rem;
            font-weight: 700;
            line-height: 20px;
        }
    }
    .sales__nav-item-active {
        border-radius: 8px;
        background: #281e04;
        p {
            color: #ffc83e;
            font-weight: 800;
        }
    }
    @media (max-width: 767px) {
        display: none;
    }
`;

export const InitialWrap = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid #cacaca;
    background: #cacaca;
    display: flex;
    align-items: center;
    justify-content: center;
    .sales__nav-initial-inner {
        border-radius: 50%;
        width: 36px;
        height: 36px;
        border: 2px solid #000;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        p {
            color: #000;
            text-align: center;
            font-size: 0.75rem;
            font-weight: 600;
            line-height: normal;
        }
    }
    /* @media (max-width: 767px) {
        display: none;
    } */
`;

export const SalesHamburger = styled.div`
    position: relative;
    display: inline-block;
    width: 23px;
    height: auto;
    top: 3px;

    .kuda-hamburger--inner {
        transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
        transition-duration: 75ms;
    }

    .kuda-hamburger--inner:after,
    .kuda-hamburger--inner:before {
        position: absolute;
        width: 20px;
        height: 2px;
        transition-timing-function: ease;
        transition-duration: 0.15s;
        transition-property: transform;
        border-radius: 4px;
        background-color: #fff;
    }

    .kuda-hamburger--inner:after,
    .kuda-hamburger--inner:before {
        display: block;
        content: "";
    }

    .kuda-hamburger--inner:before {
        top: -9px;
    }

    .kuda-hamburger--inner:before {
        transition: top 75ms ease 0.12s, opacity 75ms ease;
    }
    @media (min-width: 768px) {
        display: none;
    }
`;

export const MobileNavItemStyled = styled.nav`
    width: 100%;
    margin-top: 52px !important;
    display: flex;
    flex-direction: column;
    gap: 28px;

    .mobile-nav__items {
        p {
            color: #cacaca;
            font-size: 0.75rem;
            font-weight: 700;
        }
    }
    .mobile-nav__items-active {
        p {
            color: #ffc83e;
        }
    }
`;

export const Divider = styled.div`
    border-top: 1px solid #979797;
    margin: 0 -24px;
    margin-top: 32px;
`;

export const LogoutWrap = styled.div`
    padding-top: 24px;
    display: flex;
    align-items: center;
    gap: 4px;

    p {
        color: #fff;
        font-size: 12px;
        font-weight: 800;
        line-height: normal;
    }
`;
